import { Page } from '@/core/architecture'

import { PasswordSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

export const PasswordSettings: Page = () => {
  const { state, actions } = useViewModel()

  return <PasswordSettingsTemplate state={state} {...actions} />
}
